<div>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Verify OTP</p>
    <button type="button" aria-label="Close" (click)="modelClose()" class="close">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="form-group">
      <div *ngIf="isOtpSend">Otp Sent to Your Registered Mobile Number</div>
      <!-- <div *ngIf="isOtpValidated">Otp validated successfully</div> -->
      <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
      <label>Enter Otp</label>
      <input type="text" class="form-control col-form-label-sm" id="verifyOtp">
    </div>
     <button class="btn green_btn" type="submit" (click)="verifyOtpRequestInfo(orderObj)" [disabled]="isVerifyOtpDisable">Verify</button> 
    <!-- <button class="btn green_btn" type="submit" (click)="verifyOtpByExternal(orderObj)">Verify</button> -->
   
    <!--<button class="btn green_btn" type="submit"   (click)="sendOtpRequestInfo(orderObj.order.patientinfo.contact,this.orderObj.order.patientinfo.email)" *ngIf="isRendOtp && isHideSkipOtp">ReSend OTP</button>-->
    <button class="btn green_btn" type="submit"   (click)="sendOtpRequestInfo(orderObj.order.patientinfo.contact,this.orderObj.order.patientinfo.email)" *ngIf="isOtpSend && isHideSkipOtp">ReSend OTP</button>
    <!-- <button class="btn blue_btn  pull-right" type="submit"   (click)="skipOtp()" *ngIf="isHideSkipOtp" >Skip OTP</button> -->
    <!-- <button class="btn green_btn" type="submit"   (click)="confirmOrder(orderObj)" *ngIf="isRendOtp">Skip OTP</button> -->
  </div>

  
  <div>
 
  </div>

  <div *ngIf="isSkipOtp" class="skipOtpPanel">

    <div class="form-group">
      <label>Select Reason Type</label>
      <select class="form-control col-form-label-sm" id="reason" >
        <option>Select</option> 
        <!-- <option [ngValue]="null" disabled>Select</option> -->
        <option  *ngFor="let reason of listOfReasons">
          {{reason}} 

        </option>
      </select>
    </div>
    <div>

       <button class="btn green_btn" type="submit"   (click)="confirmOrder(orderObj)">Submit</button>
      
    </div>
  </div>

</div>
